import { createSelector, Selector } from '@reduxjs/toolkit';
import type { tSharedAppState } from '../../types';
import { IWeekCalendarState } from './types';

// Reading the slice straight off the state keeps this module out of the member
// barrel's import cycle; the parent barrel still exports its own copy.
export const selectWeekCalendarStore: Selector<tSharedAppState, IWeekCalendarState> = (
  state
) => state.shared.member.weekCalendar;

export const selectWeekCalendarPlan = createSelector(
  [selectWeekCalendarStore],
  (store) => store.plan
);

export const selectWeekCalendarWeek = createSelector(
  [selectWeekCalendarStore],
  (store) => store.week
);

/**
 * Open deliverables due today or earlier, plan-wide (§5). Null until a range has
 * landed — the plan's own overdue list is capped at three and never stands in.
 */
export const selectCatchUpTasks: Selector<tSharedAppState, number | null> = (state) =>
  selectWeekCalendarStore(state).catchUpTasks;
